import * as React from 'react';
import { createStyles, Theme, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const styles = (theme: Theme) => createStyles({
  alertBase: {
    borderRadius: '4px',
    padding: theme.spacing.unit * 2,
    display: 'flex',
    alignItems: `flex-start`,
    flexDirection: 'row'
  },
  icon: {
    marginRight: theme.spacing.unit * 2,
  },
  info: {
    backgroundColor: '#E5F6FD',
    color: '#014361',
  },
  success: {
    backgroundColor: '#EDF7ED',
    color: '#1E4620',
  },
  warning: {
    backgroundColor: '#FFF4E5',
    color: '#663C00',
  },
  error: {
    backgroundColor: '#FDEDED',
    color: '#5F2120',
  },
  bold: {
    fontWeight: "bold"
  }
});

interface IProps extends WithStyles<typeof styles> {
  severity: 'info' | 'warning' | 'error' | 'success',
  title: string
}

class Alert extends React.Component<IProps, any> {
  constructor(props: any) {
    super(props);

    this.getIcon = this.getIcon.bind(this);
  }

  public getIcon() {
    const { classes } = this.props;

    switch (this.props.severity) {
      case 'success':
        return <CheckCircleIcon className={classes.icon}/>;
      case 'info':
        return <InfoIcon className={classes.icon}/>;
      case 'warning':
        return <WarningIcon className={classes.icon}/>;
      case 'error':
        return <ErrorIcon className={classes.icon}/>;
      default:
        return <InfoIcon className={classes.icon}/>;
    }
  }

  public render() {
    const { classes, severity, title, children } = this.props;

    return (
      <div className={`${classes.alertBase} ${classes[severity]}`}>
        {this.getIcon()}
        <div>
          <Typography className={classes.bold} color="inherit">
            {title}
          </Typography>
          {children}
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Alert);


// WEBPACK FOOTER //
// ./src/modules/shared/components/Alert.tsx